var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.props.width || '24',"height":_vm.props.height || '24',"fill":"none","viewBox":"2 2 20 20"}},[_c('path',{attrs:{"fill":_vm.props.fill || '#fff',"d":"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }